import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { PropertiesBase as p } from "../common/properties-base.js";
var Banner = /*#__PURE__*/function (_p) {
  _inherits(Banner, _p);
  var _super = _createSuper(Banner);
  function Banner(t, s, i) {
    var _this;
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
    var e = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
    var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    _classCallCheck(this, Banner);
    _this = _super.call(this, o), _this.id = t, _this.placementId = s, _this.html = i, _this.xt = h, _this.isControl = r, _this.zt = e, _this.id = t, _this.placementId = s, _this.html = i, _this.xt = h, _this.isControl = r, _this.zt = e, _this.kt = !1;
    return _this;
  }
  _createClass(Banner, [{
    key: "At",
    value: function At() {
      return this.isControl;
    }
  }, {
    key: "dt",
    value: function dt() {
      return {
        id: this.id,
        pid: this.placementId,
        html: this.html,
        its: this.xt,
        ic: this.isControl,
        eat: this.zt,
        pr: this.properties
      };
    }
  }]);
  return Banner;
}(p);
export { Banner as default };